import { FormFieldTypes } from "../../../data/formFieldType";
const optionsList = [
  {label:"A",value :1},
  {label:"B",value :2},
  {label:"C",value :3},
  {label:"D",value :4},
]

export const ViewSGBSApplicationFormData = {
  name: "ViewResourcesForm",
  initialState: {
    companyName: null,
    companyUEN: null,
    mainContactPerson: null,
    mainContactPhoneCountryCode: null,
    mainContactPhone: null,
    mainContactEmailAddress: null,
    serviceCategory: null,
    areYouZCP: "no",
    zcpCategories: null

  },
  formFields: [
    {
      id: "companyInformationTitle",
      Field_Name: "companyInformationTitle",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      fieldSetting: {
        formTitle: "Company Information",
      },
      style: {
        containerCss: "col-lg-12 mb-3 text-left custom-border",
      },
    },
    {
      id: "companyName",
      lable: "Company Name",
      Field_Name: "Company Name",
      fieldType: FormFieldTypes.INPUT,
      dataField: "companyName",
      validation: [{ type: "require" }],
      fieldSetting: {
        placeholder: "",
        isDisable: true
      },
      style: {
        containerCss: "col-lg-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "companyUEN",
      lable: "Company UEN",
      Field_Name: "Company UEN",
      fieldType: FormFieldTypes.INPUT,
      dataField: "companyUEN",
      validation: [{ type: "require" }],
      fieldSetting: {
        placeholder: "",
        isDisable: true
      },
      style: {
        containerCss: "col-lg-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "typeOfCompany",
      lable: "Type of Company",
      Field_Name: "Type of Company",
      fieldType: FormFieldTypes.SELECT,
      dataField: "typeOfCompany",
      validation: [{ type: "require" }],
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isDisable: true
      },
      style: {
        containerCss: "col-lg-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      fieldType: FormFieldTypes.SEPARATOR,
      style: {
        containerCss: "separation-line pl-0 pr-0",
      },
    },
    {
      id: "applicationInformationTitle",
      Field_Name: "applicationInformationTitle",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      fieldSetting: {
        formTitle: "Application Information",
      },
      style: {
        containerCss: "col-lg-12 mb-3 text-left custom-border",
      },
    },
    {
      id: "mainContactPerson",
      lable: "Main Contact Person",
      Field_Name: "Main Contact Person",
      fieldType: FormFieldTypes.SELECT,
      dataField: "mainContactPerson",
      validation: [{ type: "require" }],
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "mainContactPhone",
      lable: "Main Contact Phone",
      Field_Name: "Main Contact Phone",
      fieldType: FormFieldTypes.INPUTGROUPSELECT,
      dataField: ["mainContactPhoneCountryCode", "mainContactPhone"],
      fieldSetting: {
        placeholder: "Select",
        allowSpace: true,
        options: [],
        isDisable: true,
      },
      validation: [{ type: "require" }],
      style: { containerCss: "col-md-6 mb-3" },
    },
    {
      id: "mainContactEmailAddress",
      lable: "Main Contact Email Address",
      Field_Name: "Main Contact Email Address",
      fieldType: FormFieldTypes.INPUT,
      dataField: "mainContactEmailAddress",
      validation: [{ type: "require" }],
      fieldSetting: {
        placeholder: "",
        isDisable: true,
      },
      style: {
        containerCss: "col-lg-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      fieldType: FormFieldTypes.SEPARATOR,
      style: {
        containerCss: "separation-line pl-0 pr-0",
      },
    },
    {
      id: "serviceDetailsTitle",
      Field_Name: "serviceDetailsTitle",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      fieldSetting: {
        formTitle: "Service Details",
      },
      style: {
        containerCss: "col-lg-12 mb-3 text-left custom-border",
      },
    },
    {
      id: "serviceCategory",
      lable: "Service Category",
      Field_Name: "Service Category",
      fieldType: FormFieldTypes.SELECT,
      dataField: "serviceCategory",
      validation: [{ type: "require" }],
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "areYouZCP",
      label: "Are you able to offer Zero Capital Partnership (ZCP) Scheme?",
      Field_Name: "Are you able to offer Zero Capital Partnership (ZCP) Scheme?",
      fieldType: FormFieldTypes.RADIOBUTTON,
      dataField: "areYouZCP",
      fieldSetting: {
        placeholder: "",
        options: [
          { label: "Yes", value: "yes", isDisable: false },
          { label: "No", value: "no", isDisable: false, optionClass: "mr-3" },
        ],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-12 col-12 mb-4 mt-2 x-position d-none",

      },
    },
    {
      fieldType: FormFieldTypes.SEPARATOR,
      style: {
        containerCss: "separation-line pl-0 pr-0",
      },
    },
    {
      id: "criteriaSelected",
      lable: "Criteria Selected",
      Field_Name: "Criteria Selected",
      fieldType: FormFieldTypes.SELECT,
      dataField: "criteriaSelected",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-6 col-md-6 col-sm-12 mb-3",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};
